export default {
  '***': {
    '***': [
      {
        "id": 10,
        "label": "Event",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          21,
          22,
        ],
      },
      {
        "id": 21,
        "label": "Event",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "Based on ad list column X (Event) in Decipher"
      },
      {
        "id": 22,
        "label": "Non-Event",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "Based on ad list column X (Event NOT selected) in Decipher"
      },
    ]
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/Hyundai/config/components/selection/Search/tagHierarchy.js